import { ERROR_CODES } from 'models/ErrorCodes';

export function getErrorMessage<T>(
	errorMap: Partial<Record<ERROR_CODES, Partial<Record<keyof T, string>>>>,
) {
	// eslint-disable-next-line @typescript-eslint/no-shadow
	return function errorMessage<T>(errorCode: ERROR_CODES, field: keyof T) {
		return (
			(errorMap[errorCode] &&
				(errorMap[errorCode] as Record<any, string>)[field]) ||
			'Error'
		);
	};
}
